import { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import lottie, { AnimationItem } from 'lottie-web';
import { FeatureList, FeatureItem } from './FeatureList';
import paywallAnim from '@/assets/animations/paywall.json';

const Hero = styled.section`
  display: grid;
  place-items: center;
`;

const Art = styled.div`
  width: 100%;
  height: 220px;
`;

const Features = styled.div`
  margin-top: 21px;
  margin-bottom: 36px;
`;

const features: FeatureItem[] = [
  { icon: '🛡️', text: 'Secure & Encrypted VPN Connection' },
  { icon: '🤖', text: 'AI Threat Detection' },
  { icon: '🔍', text: 'Secure & Private Browsing' },
  { icon: '🚀', text: 'Boosted Performance & Protection' },
];

export function PaywallHero() {
  const lottieElRef = useRef<HTMLDivElement>(null);
  const animRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    if (lottieElRef.current) {
      animRef.current = lottie.loadAnimation({
        container: lottieElRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: paywallAnim,
      });
    }

    return () => {
      animRef.current?.destroy();
    };
  }, []);

  return (
    <Hero>
      <Art aria-hidden="true">
        <div ref={lottieElRef} style={{ width: '100%', height: '220px' }} />
      </Art>
      <Features>
        <FeatureList features={features} />
      </Features>
    </Hero>
  );
}
